export type NotificationCategory =
  | "all"
  | "payments"
  | "support"
  | "tasks"
  | "recovery"
  | "customers"
  | "billing"
  | "access"
  | "general"

export type CategoryOption = {
  id: NotificationCategory
  label: string
}

export const DEFAULT_NOTIFICATION_CATEGORIES: CategoryOption[] = [
  { id: "all", label: "All" },
  { id: "payments", label: "Payments" },
  { id: "support", label: "Support" },
  { id: "tasks", label: "Tasks" },
  { id: "recovery", label: "Recovery" },
  { id: "customers", label: "Customers" },
  { id: "billing", label: "Billing" },
  { id: "access", label: "Access" },
  { id: "general", label: "General" },
]

const CATEGORY_COLOR_MAP: Record<string, string> = {
  all: "bg-slate-400",
  payments: "bg-emerald-500",
  support: "bg-violet-500",
  tasks: "bg-sky-500",
  recovery: "bg-amber-500",
  customers: "bg-indigo-500",
  billing: "bg-blue-500",
  access: "bg-rose-500",
  general: "bg-slate-500",
}

const EVENT_PREFIX_CATEGORY_MAP: Record<string, NotificationCategory> = {
  payment: "payments",
  complaint: "support",
  task: "tasks",
  recovery: "recovery",
  customer: "customers",
  invoice: "billing",
  access: "access",
}

export function categoryDotClass(category?: string | null): string {
  return CATEGORY_COLOR_MAP[String(category || "").toLowerCase()] || CATEGORY_COLOR_MAP.general
}

export function categoryLabel(category?: string | null): string {
  const key = String(category || "").toLowerCase()
  const match = DEFAULT_NOTIFICATION_CATEGORIES.find((c) => c.id === key)
  return match?.label || "General"
}

export function normalizeCategory(category?: string | null): NotificationCategory {
  const key = String(category || "").toLowerCase()
  const match = DEFAULT_NOTIFICATION_CATEGORIES.find((c) => c.id === key)
  return (match?.id || "general") as NotificationCategory
}

export function categoryFromEventType(eventType?: string | null): NotificationCategory {
  const value = String(eventType || "").toLowerCase()
  if (!value) return "general"
  const prefix = value.split(".")[0]
  return EVENT_PREFIX_CATEGORY_MAP[prefix] || "general"
}
